export const RA_ROLE_ID = 130;
export const GLOBAL_RA_ROLE_ID = 140;
export const SUPER_ADMIN_ROLE_ID = 150;
